import { Paper } from '@sanlam-glacier/app-common/components';
import { useAuth } from 'auth';
import { SideNavMenu } from 'modules/app/components/organisms/side-nav-bar/SideNavMenu';
import { TopBar } from 'modules/app/components/organisms/top-bar/TopBar';
import { ErrorPage } from 'modules/app/components/pages/error-page/ErrorPage';
import { useConfig } from 'providers/config/ConfigProvider';
import { ErrorInfo, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useLocation } from 'react-router-dom';
import './Layout.scss';
import { PageBreadcrumbs } from 'modules/app/components/molecules/page-breadcrumbs/PageBreadcrumbs';
import { logger } from '@sanlam-glacier/app-common/modules/logger';
import { BannerHolder, displayBanner } from '@sanlam-glacier/app-common/modules/banners';
import { isOnHomePage } from 'routes/route-paths';
import { BannerStaySafe } from 'modules/app/components/molecules/banner-staysafe/BannerStaySafe';
import style from './holders.module.scss';

export const AppLayout = () => {
  const authContext = useAuth();
  const currentLocation = useLocation();
  const authenticated = authContext.identificationState === 'authenticated';
  const isCurrentlyOnHomePage = isOnHomePage(currentLocation.pathname);
  const isSelectIntermediaryPage = currentLocation.pathname === '/select-intermediary';
  const [isNavMounted, setIsNavMounted] = useState(false);
  const [isMaintenanceBannerMounted, setIsMaintenanceBannerMounted] = useState(false);
  const {
    featureFlags: { shouldDisplayMaintenanceBanner }
  } = useConfig();

  const showSideNav = authenticated && !isSelectIntermediaryPage;
  const sideNavInnerClass = `default-base-layout-side-nav-inner${showSideNav ? '' : ' side-nav-hidden'}`;

  useEffect(() => {
    if (shouldDisplayMaintenanceBanner && isNavMounted && !isMaintenanceBannerMounted) {
      displayBanner({
        bannerId: 'maintenance banner',
        message:
          'Additional functionality is being made available and therefore this service will be affected or unavailable from 08:30 until 09:30 daily. If you have this app open during maintenance time,\nplease refresh your browser at 09:30 \n \nWe apologise for any inconvenience caused.\n\n',
        status: 'alert',
        title: 'System maintenance'
      });
      setIsMaintenanceBannerMounted(true);
    }
  }, [shouldDisplayMaintenanceBanner, isNavMounted, currentLocation]);

  return (
    <div className='base-layout '>
      <div className='default-base-layout-container '>
        <div className='default-base-layout-top-bar-container'>
          <TopBar />
        </div>
        {showSideNav && (
          <div className='default-base-layout-side-nav-container'>
            <Paper
              shadow={Paper.SHADOW.MEDIUM}
              elevation={true}
              className='default-base-layout-side-nav'
            >
              <SideNavMenu mountSideNav={() => setIsNavMounted(true)} />
            </Paper>
          </div>
        )}
        <div className={sideNavInnerClass} id={'main-app-content-window'}>
          <BannerHolder
            customBanner={isCurrentlyOnHomePage ? <BannerStaySafe /> : null}
            innerClassName={style.customBannerHolderInner}
            outerClassName={style.customBannerHolderOuter}
          />
          <div
            className={`default-base-layout-breadcrumb-container ${isCurrentlyOnHomePage ? 'stay-safe-online-placeholder' : ''}`}
          >
            <PageBreadcrumbs />
          </div>
          <div className='default-base-layout-content'>
            <ErrorBoundary
              FallbackComponent={ErrorPage}
              onError={(error: Error, info: ErrorInfo) => {
                logger.error({
                  message: 'Page Crash',
                  object: {
                    error,
                    info
                  },
                  includeTrace: true
                });
                return;
              }}
            >
              <Outlet />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </div>
  );
};
